import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  accessDenied: boolean;
}

const initialState: AuthState = {
  accessDenied: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessDenied: (state, action: PayloadAction<{ accessDenied: boolean }>): void => {
      state.accessDenied = action.payload.accessDenied;
    },
  },
});

export const { setAccessDenied } = authSlice.actions;

export default authSlice.reducer;
